import { useEffect } from 'react';

/**
 * Pin the app to the *visible* viewport on mobile.
 * 100vh / 100dvh still includes area behind the browser chrome, so the
 * bottom nav can sit below what the user can see and appear to scroll away.
 */
export function useAppViewport() {
  useEffect(() => {
    const root = document.documentElement;

    const sync = () => {
      const vv = window.visualViewport;
      const height = Math.round(vv?.height || window.innerHeight || 0);
      const offsetTop = Math.round(vv?.offsetTop || 0);
      if (height > 0) {
        root.style.setProperty('--mdv-app-height', `${height}px`);
      }
      root.style.setProperty('--mdv-app-top', `${offsetTop}px`);
      if (window.scrollY || window.scrollX) {
        window.scrollTo(0, 0);
      }
    };

    sync();
    window.addEventListener('resize', sync);
    window.addEventListener('orientationchange', sync);
    window.visualViewport?.addEventListener('resize', sync);
    window.visualViewport?.addEventListener('scroll', sync);

    return () => {
      window.removeEventListener('resize', sync);
      window.removeEventListener('orientationchange', sync);
      window.visualViewport?.removeEventListener('resize', sync);
      window.visualViewport?.removeEventListener('scroll', sync);
    };
  }, []);
}
